const CombinedProviders = ({ providers, children }) => {
  return providers.reduceRight((innerChildren, Provider) => {
    return <Provider>{innerChildren}</Provider>;
  }, children);
};

export default CombinedProviders;
